export default __webpack_public_path__ + "images/52e8fc5edd3796da8dee2fa8a08ad71f-hockey.webp";